
    $(document).ready(function() {
      // Disable the submit button initially
      $(".new-register").prop("disabled", true);

      // Enable the submit button when any field is filled
      $("input[type='first_name'],input[type='last_name'], input[type='email'], input[type='password']").on("input", function() {
        if (
          $("input[type='first_name']").filter(function() { return $.trim($(this).val()) !== ""; }).length > 0 &&
          $("input[type='last_name']").filter(function() { return $.trim($(this).val()) !== ""; }).length > 0 &&
          $("input[type='email']").filter(function() { return $.trim($(this).val()) !== ""; }).length > 0 &&
          $("input[type='password']").filter(function() { return $.trim($(this).val()).length >= 5; }).length > 0
        ) {
          $(".new-register").prop("disabled", false);
          $(".error-new").addClass("show-n");
        } else {
          $(".new-register").prop("disabled", true);
          $(".error-new").addClass("show");
        }
      });

      // Email format validation
      $("input[type='email']").on("input", function() {
        var email = $.trim($(this).val());
        var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

        if (email === "" || !emailRegex.test(email)) {
          $("#emailError").text("Invalid email format");
          $(".new-register").addClass('show-disb');
        } else {
          $("#emailError").text("");
          $(".new-register").removeClass('show-disb');
        }
      });
        $("input[type='first_name']").on("input", function() {
        var fname = $.trim($(this).val());
        if (fname === "") {
          $("#first_nameError").text("first name required");
        } else {
          $("#first_nameError").text("");
        }
      });
      $("input[type='last_name']").on("input", function() {
        var lname = $.trim($(this).val());
        if (lname === "") {
          $("#last_nameError").text("last name required");
        } else {
          $("#last_nameError").text("");
        }
      });
       

      // Password length validation
      $("input[type='password']").on("input", function() {
        var password = $.trim($(this).val());

        if (password.length < 5) {
          $("#passwordError").text("Password must be at least 5 characters long");
          $(".new-register").addClass('show-new');
        } else {
          $("#passwordError").text("");
           $(".new-register").removeClass('show-new');
        }
      });
      // new contact page validation


      

    });

  
